export default __webpack_public_path__ + "static/media/pwd2.7eb8a39f.svg";